import { render, staticRenderFns } from "./ReviewListContent.vue?vue&type=template&id=2a863be7&scoped=true&"
import script from "./ReviewListContent.vue?vue&type=script&lang=js&"
export * from "./ReviewListContent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListContent.vue?vue&type=style&index=0&id=2a863be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a863be7",
  null
  
)

export default component.exports